import React, { FC } from 'react';
import Form from 'components/Form';

import { BiofreezePageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Biofreeze: FC<BiofreezePageProps> = ({ pageContext, location }) => (
  <Form
    {...{
      ...{ ...pageContext, location, translations: { ...pageContext.translations, pageTitle: '' } },
    }}
  />
);

export default Biofreeze;
